<template>
  <nav id="side-nav"
    class="lg:ut-fixed"
    :class="isActive ? 'nav-bg ut-fixed ut-h-full': 'ut-bg-N100'">

    <!--Nav Top section starts-->
    <!--Prevent the old logo flashing before the page fully loaded-->
    <div v-if="user.key" class="ut-pt-6 ut-px-6 ut-pb-4
      ut-inline-block ut-w-full ut-flex ut-cursor-pointer logo">      
      <div class="ut-float-left ut-content-center ut-ml-0" 
           v-on:click="goToHome()">
        <img v-if="isPremier" src="@/assets/styles/frontend-library/images/logo-openagent-green-white-premier.svg"
              alt="OpenAgent" width="210"
              class="lg:ut-block"
              :class="isActive ? 'ut-block': 'ut-hidden'">
        <img v-else src="@/assets/styles/frontend-library/images/logo-openagent-green-white.svg"
             alt="OpenAgent" width="128"
             class="lg:ut-block"
             :class="isActive ? 'ut-block': 'ut-hidden'">
        <img src="@/assets/styles/frontend-library/images/logo-openagent-green-grey.svg"
             alt="OpenAgent"
             width="128"
             class="ut-block lg:ut-hidden"
             :class="!isActive ? 'ut-block': 'ut-hidden'">
      </div>
      <div class="ut-float-right ut-content-center ut-text-right ut-mr-0 lg:ut-hidden"
        @click="isActive = !isActive">
      <img src="@/assets/styles/frontend-library/images/mobile-menu-icon.svg"
        alt="OpenAgent" width="18"
        class="lg:ut-block"
        :class="!isActive ? 'ut-block': 'ut-hidden'">
      <img src="@/assets/styles/frontend-library/images/cross-icon.svg"
        alt="OpenAgent" width="16"
        class="ut-block lg:ut-hidden"
        :class="isActive ? 'ut-block': 'ut-hidden'">
      </div>
    </div>
    <!--Nav Top section ends-->

    <div :class="isActive ? 'ut-block': 'ut-hidden'" class="lg:ut-block">

      <!--Nav Header-->
      <header>
        <slot name="header"></slot>
      </header>

      <!--Nav Body-->
      <div class="side-nav-body">
        <slot :closeNav="closeNav"></slot>
      </div>

      <!--Nav Footer-->
      <!--TODO-->

    </div>
  </nav>
</template>

<script>

import { mapState, mapGetters } from 'vuex';

export default {
  name: 'SideNav',
  props: {},
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
      user: state => state.userStore.user,
    }),
    ...mapGetters('userStore', [
      'isPremier',
      'isPrincipal',
      'isManager',
    ]),
  },
  data() {
    return {
      isActive: false,
      premier: false,
    };
  },
  methods: {
    goToHome() {
      this.closeNav();

      if (this.$route.params.ak) {
        this.$router.push({ name: 'leads', params: { ak: this.agent.key } });
      } else {
        this.$router.push({ name: 'dashboard', params: { uk: this.user.key } });
      }
    },
    closeNav() {
      this.isActive = false;
    },
  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    #side-nav {
        // overflow-y: auto;
        // overflow-x: hidden;
        @apply ut-w-full;

        &.nav-bg {
          background-color: #282828;
        }

        @screen lg {
            width: 280px;
            z-index: 99;
            @apply ut-h-full;
            background-color: #282828;
        }

        .side-nav-body {

        }
    }
</style>
